module.exports = __webpack_public_path__ + "fonts/iconfont.7a4e17de.woff2";